<template>
    <div class="landing-bg">
        <HeaderLanding />

    <!-- Hero Section -->
    <section class="hero">
        <div class="landing-survey-container">
            <!-- Text Centered -->
            <div class="landing-survey-text">
            <h1>
                SurPriz.ing: A Smart Loyalty & Feedback System for 
                <span class="msme-svg-wrapper">MSMEs</span>
            </h1>
            <p class="desktop-text">
                AI-powered customer engagement platform designed to help businesses collect valuable customer
                feedback and enhance customer loyalty through a seamless e-voucher and collect point system.
            </p>
            <p class="mobile-text"> An AI-driven platform that helps businesses gather customer feedback and boost loyalty with an easy e-voucher system.</p>
            <button class="landing-survey-cta-btn">
                <span class="landing-survey-cta-text" @click="OpenApp()">Start Now</span>
                <span class="btn-icon-circle">
                <img src="@/assets/img/arrow-right black.png" alt="arrow right" class="landing-survey-arrow-icon" />
                </span>
            </button>
            </div>

            <!-- Cards & Phone -->
            <div class="landing-survey-frame">
                <img src="@/assets/img/card.png" class="card card1" />
                <img src="@/assets/img/card2.png" class="card card2" />
                
                <div class="landing-survey-phone">
                    <img src="@/assets/img/landing-layout-phone.png" alt="Phone Mockup" />
                </div>
                
                <img src="@/assets/img/card3.png" class="card card3" />
                <img src="@/assets/img/card4.png" class="card card4" />
            </div>
        </div>
    </section>

    <!-- Why Choose Section -->
    <section class="why-choose">
        <div class="why-choose-wrapper">
            <div class="headline-section">
            <div class="heading">Why Choose SurPriz.ing?</div>
            <div class="description">
                SurPriz.ing offers a simple yet powerful way for businesses to gather customer feedback via QR-based surveys while rewarding customers with digital evouchers or collect points.
            </div>
            </div>

            <div>
            <img src="@/assets/img/FBads.png" class="video-preview"/>
            <!-- <span>Video Placeholder</span> -->
            </div>
        </div>
    </section>

    <!-- Stats Section -->
    <section class="stats-section">
        <div class="metrics-container">
        <div class="metric-card">
            <div class="metric-value">150K+</div>
            <div class="metric-label">Merchants Engaged</div>
        </div>
        <div class="metric-card">
            <div class="metric-value">25+</div>
            <div class="metric-label">Customer Satisfaction</div>
        </div>
        <div class="metric-card">
            <div class="metric-value">60+</div>
            <div class="metric-label">e-Voucher Listings</div>
        </div>
        <div class="metric-card">
            <div class="metric-value">1,200+</div>
            <div class="metric-label">Points Collected</div>
        </div>
        <!-- Optional SVG/ornament image -->
        <img class="ornament" src="/path/to/Ornament69.svg" alt="Ornament" />
        </div>
    </section>

    <section class="app-preview">
        <h2>How do you build customer loyalty with SurPriz.ing?</h2>
        <p>Feedback is more than data — it’s your path to loyalty. SurPriz.ing makes it rewarding.</p>
    </section>

    <!-- Feature Highlight Section -->
    <section class="ai-loyalty-section">
        <div class="ai-loyalty-container">
            <!-- Text Section -->
            <div class="ai-feedback-section">
                <div class="ai-loyalty-container">
                    <!-- Text on the left  -->
                    <div class="ai-loyalty-text first-text">
                    <h3 class="ai-loyalty-title">Elevate Customer Loyalty with AI-Powered Feedback</h3>
                    <p class="ai-loyalty-description">
                        Listening to your customers is just the beginning. SurPriz.ing captures real-time feedback through QR-based surveys and transforms it into actionable insights using AI analysis. Know what your customers love, and where you can improve — all in one simple platform.
                    </p>

                    <button class="ai-learn-more-btn">Learn More</button>
                    </div>

                    <!-- Image on the right -->
                    <div class="ai-loyalty-image-box">
                    <img src="@/assets/img/scan-screen.jpg" class="scan-screen-img" alt="Phone Feedback Screen" />
                    </div>
                </div>
            </div>

            <div class="timeline-line-wrapper">
                <img src="@/assets/img/line-gradient.png" class="line-gradient-img" alt="line" />
            </div>

            <div class="ai-rewards-section">
                <div class="ai-loyalty-container">
                    <!-- Image on the left -->
                    <div class="reward-mockup-box">
                    <img src="@/assets/img/claim-reward-screen.png" alt="Claim Reward Screen" />
                    </div>

                    <!-- Text on the right -->
                    <div class="ai-loyalty-text second-text">
                    <h2 class="ai-loyalty-title">Strengthen Business Relationships with Digital Rewards</h2>
                    <p class="ai-loyalty-description">
                        Reward your loyal customers with e-vouchers or collect points—automatically and effortlessly.
                        SurPriz.ing lets you define your own reward rules, monitor campaign effectiveness, and keep your customers coming back for more.
                    </p>
                    <button class="ai-learn-more-btn">Learn More</button>
                    </div>
                </div>
            </div>
        </div>
    </section>
        


        <!-- Explore Live Platform CTA Section -->
    <section class="real-surveys-section">
        <div class="real-surveys-container">
            <div class="real-surveys-text">
            <h2>Start Earning with Real Surveys</h2>
            <p>
                Visit the live SurPriz.ing platform and try real surveys, give feedback, and start collecting rewards now!
            </p>
            <button class="explore-btn">Explore Live Platform</button>
            </div>
            <div class="real-surveys-mockup">
                <div class="mockup-platform"> <!-- make sure this class name is used -->
                    <img src="@/assets/img/dashboard-card.png" alt="Dashboard platform preview" />
                </div>
            </div>
        </div>
    </section>

        <section class="benefits-section">
            <div class="benefits-header">
                <div class="header-text">
                <h2>Benefits of Using Our<br /> Program</h2>
                <p>Want to strengthen customer loyalty and improve your business? Here’s what you’ll gain by using SurPriz.ing:</p>
                </div>
                <div class="header-graphic">
                <!-- You can use an SVG or an image for the 76% circle -->
                <div class="ellipse-wrapper">
                    <div class="bg-ring"></div>
                    <img src="@/assets/img/Ellipse 1.png" class="arc arc-1" />
                    <img src="@/assets/img/Ellipse 2.png" class="arc arc-2" />
                    <img src="@/assets/img/Scan copy.png" class="scan-icon" />
                    <div class="arc-text">
                    <h2>76%</h2>
                    <p>strengthen customer<br />loyalty</p>
                    <div class="arc-button">AI</div>
                    </div>
                </div>

                </div>
            </div>

            <div class="benefits-grid">
                <div class="benefit-card">
                    <div class="icon-inner">
                        <img src="@/assets/img/discount-shape copy.png" alt="Real-Time Feedback">
                    </div>
                    <div class="headline">
                    <h4>Real-Time Feedback</h4>
                    <p>Customers scan a QR code to share their thoughts instantly — no app needed. It’s quick, seamless, and engaging.</p>
                    </div>
                </div>
                <div class="benefit-card">
                    <div class="icon-inner">
                        <img src="@/assets/img/tiket-discount.png" alt="Smarter Insights">
                    </div>
                    <div class="headline">
                    <h4>Smarter Insights</h4>
                    <p>Leverage AI to analyze feedback and discover patterns, satisfaction trends, and areas for improvement — so you can take action that truly impacts your business.</p>
                    </div>
                </div>
                <div class="benefit-card">
                    <div class="icon-inner">
                        <img src="@/assets/img/menu-board.png" alt="Smarter Insights">
                    </div>
                    <div class="headline">
                    <h4>Higher Engagement</h4>
                    <p>Show customers that their opinions matter. SurPriz.ing helps you respond to feedback effectively and build stronger relationships through transparency and trust.</p>
                    </div>
                </div>
                <div class="benefit-card">
                    <div class="icon-inner">
                        <img src="@/assets/img/document-like.png" alt="Smarter Insights">
                    </div>
                    <div class="headline">
                    <h4>Earn Points Easily</h4>
                    <p>After submitting feedback, customers automatically earn points for their participation, encouraging them to keep coming back.</p>
                    </div>
                </div>
                <div class="benefit-card">
                    <div class="icon-inner">
                        <img src="@/assets/img/monitor-mobbile.png" alt="Smarter Insights">
                    </div>
                    <div class="headline">
                    <h4>Flexible Rewards</h4>
                    <p>Points collected can be redeemed for exciting rewards — from discounts to freebies — all defined by your business.</p>
                    </div>
                </div>
                <div class="benefit-card">
                    <div class="icon-inner">
                        <img src="@/assets/img/gift-icon.png" alt="Smarter Insights">
                    </div>
                    <div class="headline">
                    <h4>Boost Retention</h4>
                    <p>By combining smart feedback with instant rewards, SurPriz.ing keeps your customers engaged and returning — turning satisfaction into loyalty.</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="brand-section">
            <div class="brand-container">
            <h2 class="brand-heading">Our Brand</h2>
            <div class="brand-logos">
                <img src="@/assets/img/yomaro-logo.png" alt="Yomaro" class="brand-logo" />
                <img src="@/assets/img/pickiddo-logo.png" alt="Pickiddo" class="brand-logo" />
                <img src="@/assets/img/prestige-logo.png" alt="Prestige" class="brand-logo" />
                <img src="@/assets/img/logo3.png" alt="Logo 3" class="brand-logo" />
                <img src="@/assets/img/BMW-logo.png" alt="BMW" class="brand-logo" />
                <img src="@/assets/img/ford-logo.png" alt="Ford" class="brand-logo" />
                <img src="@/assets/img/kia-logo.png" alt="Kia" class="brand-logo" />
            </div>
            </div>
        </section>

        <section class="how-it-works-section">
            <!-- Grid background -->
            <div class="grid-wrapper">
                <div class="line">
                <div class="square" v-for="n in 21" :key="n" />
                </div>
            </div>

            <div class="how-it-works-container">
                <h2 class="how-title">How It Works</h2>
                <p class="how-subtitle">
                Simple steps to collect feedback and deliver rewards that drive loyalty.
                </p>

                <div class="how-steps">
                <div class="how-step">
                    <div class="step-circle">1</div>
                    <img src="@/assets/img/scan-barcode.png" class="how-icon" alt="Give Feedback" />
                    <h3>Give Feedback</h3>
                    <p>
                    After a purchase or service, customers simply scan a QR code displayed at your store.
                    They’re taken to a short and engaging feedback form, which they can complete in seconds.
                    </p>
                </div>
                <div class="how-step">
                    <div class="step-circle">2</div>
                    <img src="@/assets/img/receipt-discount.png" class="how-icon" alt="Receive e-Voucher or Points" />
                    <h3>Receive e-Voucher or Points</h3>
                    <p>
                    Once the feedback is submitted, the system instantly rewards them with a digital e-voucher
                    or collect points. These are personalized, secure, and automated.
                    </p>
                </div>
                <div class="how-step">
                    <div class="step-circle">3</div>
                    <img src="@/assets/img/gift copy.png" class="how-icon" alt="Enjoy Your Rewards" />
                    <h3>Enjoy Your Rewards</h3>
                    <p>
                    Customers can use their points or vouchers on their next visit — whether it’s for discounts,
                    freebies, or special offers. This seamless process keeps them coming back and builds loyalty.
                    </p>
                </div>
                </div>
            </div>
        </section>

    <section class="voucher-section">
        <div class="voucher-header">
            <h2>Empower Customer Loyalty with Redeem Rewards</h2>
            <p>
            With SurPriz.ing, you can collect real-time feedback, reward customers instantly with points or digital vouchers, and unlock actionable insights — all from one simple platform. Drive engagement, improve satisfaction, and encourage repeat visits with ease.
            </p>
        </div>

        <div class="voucher-grid">
            <div class="voucher-card">
            <img src="@/assets/img/voucher1.png" alt="Tony Roma’s Voucher" />
            <div class="voucher-info">
                <h4>October 2024 Steak Extravaganza at Tony Roma’s Malaysia!</h4>
                <p class="expire-label">Expired Date</p>
                <p class="expire-date">31/10/2024</p>
            </div>
            </div>

            <div class="voucher-card">
            <img src="@/assets/img/voucher2.png" alt="Diwali Flight Deals" />
            <div class="voucher-info">
                <h4>Diwali Flight Deals: Fly to Hanoi and Ho Chi Minh City from Kuala Lumpur for Just RM166</h4>
                <p class="expire-label">Expired Date</p>
                <p class="expire-date">31/10/2024</p>
            </div>
            </div>

            <div class="voucher-card">
            <img src="@/assets/img/voucher3.png" alt="LEGOLAND Halloween" />
            <div class="voucher-info">
                <h4>October-November 2024: LEGOLAND Malaysia Halloween Special – 35% Off Tickets!</h4>
                <p class="expire-label">Expired Date</p>
                <p class="expire-date">31/10/2024</p>
            </div>
            </div>

            <div class="voucher-card">
            <img src="@/assets/img/voucher4.png" alt="AirAsia Specials" />
            <div class="voucher-info">
                <h4>AirAsia Specials: All-in Fare Round Trip from RM69 with Trip.com – Exclusive Deals Every Week!</h4>
                <p class="expire-label">Expired Date</p>
                <p class="expire-date">31/10/2024</p>
            </div>
            </div>

            <div class="voucher-card">
            <img src="@/assets/img/voucher5.png" alt="Burger King" />
            <div class="voucher-info">
                <h4>Burger King Malaysia: RM11.95 Delivery Deals – Satisfy Your Cravings at Home!</h4>
                <p class="expire-label">Expired Date</p>
                <p class="expire-date">31/10/2024</p>
            </div>
            </div>

            <div class="voucher-card">
            <img src="@/assets/img/voucher6.png" alt="myNEWS Maru Deal" />
            <div class="voucher-info">
                <h4>Grab a Delicious Maru MealDeal at myNEWS: Wrap or Croissant & Coffee for RM12.99!</h4>
                <p class="expire-label">Expired Date</p>
                <p class="expire-date">31/10/2024</p>
            </div>
            </div>

            <div class="voucher-card">
            <img src="@/assets/img/voucher7.png" alt="Lotus’s Groceries" />
            <div class="voucher-info">
                <h4>Lotus’s Malaysia: Stock Up on Groceries with Unbeatable Prices on October 2024</h4>
                <p class="expire-label">Expired Date</p>
                <p class="expire-date">31/10/2024</p>
            </div>
            </div>

            <div class="voucher-card">
            <img src="@/assets/img/voucher8.png" alt="7-Eleven Drinks" />
            <div class="voucher-info">
                <h4>Quench Your Thirst with 7-Eleven’s Crazy Wednesday RM1 Drinks Deal!</h4>
                <p class="expire-label">Expired Date</p>
                <p class="expire-date">31/10/2024</p>
            </div>
            </div>
        </div>

        <button class="more-btn">More</button>
    </section>

    <FooterLanding />


    </div>
</template>

<script>
import HeaderLanding from '@/components/HeaderLanding.vue'
import FooterLanding from '@/components/FooterLanding.vue'

export default {
    name: 'LandingPage',
    components: {
        HeaderLanding,
        FooterLanding
    },
    computed: {
        isAboutPage() {
            return this.$route.path === "/about-us";
        }
    },
    props: {
        mode: {
            type: String,
            default: 'default'
        }
    },
    mounted() {
        const btn = document.querySelector('.more-btn');
        const grid = document.querySelector('.voucher-grid');

        if (btn && grid) {
            btn.addEventListener('click', () => {
                grid.classList.toggle('show-all');
                btn.textContent = grid.classList.contains('show-all') ? 'Less' : 'More';
            });
        }
    },
    methods:{
        OpenApp()
        {
            window.open("https://app.surpriz.ing/");
        }
    }
}
</script>




<style scoped>
.landing-bg {
    /* background: linear-gradient(180deg, #7970EF 0%, #7970EF 60%, #FFFFFF 100%); */
    font-family: 'Inter', sans-serif;
    box-sizing: border-box;
    min-height: 100vh;
    overflow-x: hidden;
}

/* Hero Section */
.hero {
    background: linear-gradient(180deg, #7970EF 0%, #7970EF 30%, #FFFFFF 90%);
    padding: 15px 0 60px;
    text-align: center;
    position: relative;
    overflow: visible;
}
.landing-survey-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}
.landing-survey-text {
    max-width: 975px;
    margin: 0 auto 24px;
    text-align: center;
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.landing-survey-text h1 {
    font-size: 64px;
    letter-spacing: -2px;
    line-height: 1.1;
    font-weight: 500;
    color: #fff;
    margin-bottom: 0;
}
.landing-survey-text p {
    font-size: 18px;
    line-height: 1.7;
    color: #fff;
    margin-top: 14px;
    margin-bottom: 24px;
    max-width: 905px;
}
.desktop-text {
    display: block;
}

.mobile-text {
    display: none;
}
.landing-survey-cta-text {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
}

.msme-svg-wrapper {
    display: inline-block;
    margin-left: -10px;
    transform: translateY(5px); 
    background-image: url('../assets/img/MSME.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    width: 239px;
    height: 99px;
    font-size: 55px;
    color: white;
    text-align: center;
    line-height: 82px;
    user-select: none;
}

.landing-survey-cta-btn {
    border-radius: 58px;
    background: #111116;
    margin-bottom: 56px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 16px;
    gap: 12px;
    font-size: 16px;
    color: #fff;
    border: none;
    cursor: pointer;
    font-weight: 500;
}

.btn-icon-circle {
    width: 24px;
    height: 24px;
    border-radius: 100px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
}
.landing-survey-arrow-icon {
    width: 24px;
    height: 24px;
    display: block;
}
.landing-survey-cta-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}

.landing-survey-frame {
    position: relative;
    width: 100%;
    height: 500px;
    margin-top: 40px;
    margin-bottom: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.landing-survey-phone {
    position: relative;
    z-index: 3;
}

.landing-survey-phone img {
    max-height: 500px;
    width: auto;
    display: block;
    margin: 0 auto;
    filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.2));
}


/* Floating Cards */
.card {
    position: absolute;
    border-radius: 6px;
    box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.69), 0 12px 40px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease;
    z-index: 1;
}

.card:hover {
    transform: translateY(-8px);
}

.card1 {
    width: 180px;
    top: -110px;
    left: -50px;
    transform: rotate(-12deg);
}

.card2 {
    width: 300px;
    bottom: 50px;
    left: -80px;
}

.card3 {
    width: 180px;
    top: -85px;
    right: -50px;
    transform: rotate(-6deg);
}

.card4 {
    width: 306px;
    height: 245px;
    bottom: 130px;
    right: -144px;
    left: auto;
}

.why-choose {
    background: #fff;
    padding: 88px 120px 64px;
}

.why-choose-wrapper {
    max-width: 1200px;
    margin: 0 auto;
}

.headline-section{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0;
    font-family: Inter;
    margin-bottom: 64px;
}

.heading {
    width: 440px;
    font-size: 52px;
    font-weight: 600;
    color: #1a1a1a;
    line-height: 120%;
}

.description {
    width: 642px;
    font-size: 18px;
    color: #737373;
    line-height: 26px;
}

.video-preview {
    width: 100%;
    height: 100%;
    background: #f0f0f0;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    font-style: italic;
}


/* Stats Section */
.stats-section {
    padding: 88px 0;
    background-color: white;
}

.metrics-container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    border-radius: 40px;
    background: linear-gradient(194.52deg, #7970ef, #9792dc);
    padding: 80px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
    position: relative;
    color: #fafafa;
    text-align: center;
    font-family: 'Inter', sans-serif;
}

.metric-card {
    width: 238px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: center;
    align-items: center;
    z-index: 1;
}

.metric-value {
    font-size: 56px;
    font-weight: 600;
    line-height: 120%;
}

.metric-label {
    font-size: 20px;
    font-weight: 500;
    line-height: 140%;
}

.ornament {
    position: absolute;
    width: 1167px;
    height: auto;
    top: -510px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.1;
    z-index: 0;
}

.app-preview {
    padding: 80px 20px;
    background-color: #ffffff;
    text-align: center;
}

.app-preview h2 {
    font-size: 52px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 16px;
}

.app-preview p {
    font-size: 18px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 60px;
    font-family: "Inter";
}


/* Decorative Line */
.decorative-line {
        width: 100%;
        height: 166px;
        position: relative;
        overflow: hidden;
}
.decorative-line-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
}


/* AI Loyalty Section */
.ai-loyalty-section {
    width: 100%;
    padding: 0 80px;
    background-color: #ffffff;
}
.ai-loyalty-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 60px;
    flex-wrap: wrap;
}

.ai-loyalty-text {
    flex: 1 1 480px;
}

.ai-loyalty-title {
    font-size: 40px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 20px;
    line-height: 120%;
}

.ai-loyalty-description {
    font-size: 18px;
    font-weight: 400;
    line-height: 26px;
    color: #4f4f4f;
    margin-bottom: 20px;
}

.ai-learn-more-btn {
    background-color: #000;
    color: #fff;
    padding: 12px 24px;
    border-radius: 999px;
    border: none;
    cursor: pointer;
    font-weight: 600;
}

.ai-loyalty-image-box {
    width: 100%;
    max-width: 497.6px;
    height: 436px;
    position: relative;
    border-radius: 24px;
    background: linear-gradient(179.93deg, #eeddea, #ffffff);
    overflow: hidden;
    flex-shrink: 0;
    margin: 0 auto;
}

.scan-screen-img {
    position: absolute;
    top: calc(50% - 179.63px); /* From Figma */
    left: 50%;
    transform: translateX(-50%);
    width: 424.6px; /* Figma exact width */
    height: 921.4px; /* Figma height */
    object-fit: cover;
    border-radius: 24px;
}

.timeline-line-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -56px;
    margin-bottom: -66px;
    z-index: 0;
}

.line-gradient-img {
    width: 100%;
    max-width: 660px; /* or set as needed */
    height: auto;
    object-fit: contain;
    display: block;
}

.reward-mockup-box {
    width: 100%;
    max-width: 497.6px;
    height: 436px;
    position: relative;
    border-radius: 24px;
    background: linear-gradient(179.93deg, #eeddea, #ffffff);
    overflow: hidden;
    flex-shrink: 0;
    margin: 0 auto;
}

.reward-mockup-box img {
    position: absolute;
    top: calc(50% - 179.63px);
    left: 50%;
    transform: translateX(-50%);
    width: 424.6px;
    height: 921.4px;
    object-fit: cover;
    border-radius: 24px;
}

/* Live Platform CTA Section */
/* Outer section: full width with light background */
.real-surveys-section {
  background: #FAFAFA;
  padding: 100px 0;
}

/* Container becomes the purple box */
.real-surveys-container {
  background: linear-gradient(135deg, #a38af7, #8e9cf7);
  position: relative;
  padding: 80px 60px;
  border-radius: 20px;
  overflow: hidden;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
  z-index: 1;
}

/* Grid overlay */
.real-surveys-container::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(to right, rgba(255,255,255,0.1) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(255,255,255,0.1) 1px, transparent 1px);
  background-size: 40px 40px;
  z-index: 0;
}

.real-surveys-text {
  flex: 1 1 50%;
  max-width: 520px;
  color: white;
}

.real-surveys-text h2 {
  font-size: 42px;
  font-weight: bold;
  margin-bottom: 20px;
}

.real-surveys-text p {
  font-size: 18px;
  margin-bottom: 24px;
  line-height: 1.6;
}

.explore-btn {
  padding: 14px 26px;
  font-weight: bold;
  background: white;
  color: #000;
  border-radius: 999px;
  border: none;
  cursor: pointer;
}

.real-surveys-mockup {
  flex: 1 1 50%;
  max-width: 520px;
  display: flex;
  justify-content: flex-end;
}

.mockup-platform {
  padding: 24px;
  background: linear-gradient(179.93deg, #a389f1, #7a60f1);
  border-radius: 28px;
  display: inline-block;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  max-width: 500px;
}


.mockup-platform img {
  width: 100%;
  height: auto;
  border-radius: 16px;
  display: block;
}


/* benefit section - 6 grids */

.benefits-section{
    background: #F6F7F9;
    width: auto;
    height: auto;
    padding: 80px;
}
.benefits-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 70px; /* optional: adds spacing between text and graphic */
    padding: 40px 0;
    flex-wrap: wrap; /* allows wrapping on smaller screens */
}

.benefits-header h2 {
    font-family: 'Inter', sans-serif;
    color: #000;
    font-weight: 600;
    font-size: 48px;
    line-height: 120%;
    letter-spacing: 0;
}
.benefits-header p {
    font-family: 'Inter', sans-serif;
    color: #000;
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
    letter-spacing: 0;
}
.ellipse-wrapper {
    position: relative;
    width: 220px;
    height: 220px;
    margin: 0 auto;
}

.bg-ring {
    width: 100%;
    /* height: 100%; */
    height: 235.4px;
    border-radius: 50%;
    /* background: rgba(0, 0, 0, 0.04); */
    position: absolute;
    top: 0;
    left: 0;
}

.arc {
    position: absolute;
    width: 200px;
    height: 200px;
    top: 12px;
    left: 9px;
    pointer-events: none;
}

.arc-1 {
    z-index: 2;
}

.arc-2 {
    position: absolute;
    width: 200px;
    height: 200px;
    top: -54px;
    left: 67px;
    z-index: 3;
    transform: rotate(-3deg) scale(0.40);
    transform-origin: center center;
    pointer-events: none;
}

.scan-icon {
    position: absolute;
    width: 39px;
    height: 39px;
    top: 63px;     /* tweak this to align better */
    left: 181px;   /* adjust for perfect placement */
    z-index: 5;
    background: white;
    border-radius: 50%;
    padding: 10px;
    border-color: #3B3B3B14;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}


.arc-text {
    position: absolute;
    top: 53%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 4;
}

.arc-text h2 {
    width: 100%;
    position: relative;
    font-size: 45px;
    letter-spacing: -1.5px;
    line-height: 120%;
    font-weight: 550;
    color: #111116;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
}

.arc-text p {
    width: 151px;
    position: relative;
    font-size: 13px;
    line-height: 130%;
    font-weight: 500;
    color: rgba(59, 59, 59, 0.72);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 33px;
}

.arc-button {
    position: absolute;
    bottom: -49px; 
    right: 93px;
    background: #FFFFFFB8;
    border-radius: 100px;
    padding: 13px 17.39px 9.92px 16.4px;
    font-weight: bold;
    border-color: #3B3B3B14;
    font-size: 13px;
    z-index: 5;
}


.benefits-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    gap: 28px;
}

.benefit-card {
    display: flex;
    gap: 24px;
    padding: 40px;
    background-color: #fff;
    border: 1px solid #dcdcdc;
    border-radius: 24px;
    box-sizing: border-box;
    font-family: Inter, sans-serif;
    align-items: flex-start;
}
.benefit-card:hover {
    background-color: #F1EFFF; /* soft purple */
    border: 1px solid #A38AF7; /* vivid purple */
    transition: all 0.3s ease;
    cursor: pointer;    
}

.icon-inner {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-inner img {
    width: 50px;
    height: 50px;
    object-fit: contain;
    border-radius: 12px;
}



.headline {
    display: flex;
    flex-direction: column; /* Stack heading above paragraph */
    justify-content: center;
    /* gap: 24px; */
    font-family: Inter;
}

.headline h4 {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    color: #171717;
    line-height: 30px;
}

.headline p {
    font-size: 18px;
    color: #666d80;
    /* margin-top: 4px; */
    line-height: 24px;
    margin-bottom: 0;
}


/* brand-section */
.brand-section {
    width: 100%;
    background-color: #f9fafb;
    padding: 80px 0;
}

.brand-container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
}

.brand-heading {
    font-size: 36px;
    font-weight: 600;
    color: #171717;
    text-align: center;
}

.brand-logos {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
}

.brand-logo {
    width: 110px;
    height: 110px;
    border-radius: 12px;
    border: 2px solid #eaecf0;
    background-color: #fff;
    padding: 16px;
    box-sizing: border-box;
    object-fit: contain;
}



/* HOW IT WORKS SECTION STYLES */
.how-it-works-section {
    background-color: #7970EF;
    background-image: 
        repeating-linear-gradient(
        to right,
        rgba(255, 255, 255, 0.05) 0,
        rgba(255, 255, 255, 0.05) 1px,
        transparent 1px,
        transparent 96px
        );
}


/* Grid layer */
.grid-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1px;
    z-index: 0;
    opacity: 0.3;
}

.line {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}

.square {
    width: 69.9px;
    height: 69.9px;
    border: 1.4px solid rgba(255, 255, 255, 0.05);
    box-sizing: border-box;
}

.square3 {
    background-color: rgba(255, 255, 255, 0.05);
}

.how-it-works-container {
    position: relative;
    z-index: 1;
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;
}

.how-title {
    font-size: 36px;
    font-weight: bold;
    color: white;
}

.how-subtitle {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 60px;
}

.how-steps {
    display: flex;
    justify-content: space-between;
    gap: 40px;
    flex-wrap: wrap;
    position: relative;
}

.how-step {
    flex: 1;
    padding: 40px 20px;
    text-align: center;
    color: white;
}

.step-circle {
    background-color: white;
    color: #7b61ff;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 10px auto;
    font-size: 16px;
}

.how-icon{
    width: 54px;
    height: 54px;
    background-color: rgba(255, 255, 255, 0.1);
    border: 1.5px solid #928AFD;
    border-radius: 16px;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 20px; /* center and add space below */
    box-sizing: border-box;
}

.how-step h3 {
    font-size: 20px;
    font-weight: 500px;
    margin-top: 20px;
    color: white;
    line-height: 150%;
}

.how-step p {
    font-size: 16px;
    margin-top: 10px;
    color: rgba(255, 255, 255, 0.85);
    line-height: 150%;
    font-weight: 400px;

}

/* voucher section */
.voucher-section {
    padding: 80px;
    background-color: #fff;
}

.voucher-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0;
    font-family: Inter;
    margin-bottom: 64px;
    flex-wrap: wrap; 
}

.voucher-header h2{
    width: 520px;
    font-size: 36px;
    font-weight: 600;
    color: #1a1a1a;
    line-height: 44px;
    letter-spacing: -0.72px; 
}
.voucher-header p{
    width: 535px;
    font-size: 16px;
    color: #696969;
    line-height: 24px;
}

.voucher-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 24px;
}

.voucher-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #EAECF0;
    box-shadow: 0 2px 6px rgba(0,0,0,0.05);
    display: flex;
    flex-direction: column;
}

.voucher-card img {
    width: 100%;
    height: auto;
}

.voucher-info {
    padding: 12px 16px;
}

.voucher-info h4 {
    font-size: 16px;
    margin: 0 0 10px;
}

.expire-label {
    font-size: 12px;
    color: #999;
    margin: 0;
}

.expire-date {
    font-size: 13px;
    font-weight: bold;
}

.more-btn {
    width: 186px;
    margin: 40px auto 0;
    display: block;
    padding: 16px;
    background-color: #FFFFFF;
    border: 1px solid #DFE1E7;
    border-radius: 12px;
    box-shadow: 0px 1px 3px rgba(13, 13, 18, 0.05), 
                0px 1px 2px rgba(13, 13, 18, 0.04);
    color: #171717;
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
    gap: 8px;
}



@media (max-width: 768px) {

    .landing-survey-container{
        max-width: 1200px;
        max-height: 427px;
    }
    .hero{
        padding:0;
    }
    .ornament{
        display: none;
    }
    .desktop-text {
        display: none;
    }
    .mobile-text {
        display: block;
    }
    .timeline-line-wrapper {
        display: none;
    }

    .line-gradient-img {
        display: none;
    }
    .landing-survey-text h1 {
        font-size: 28px;
        letter-spacing: -2px;
        line-height: 114.99999999999999%;
        font-weight: 500;
        color: #fff;
        margin-bottom: 0;
    }
    .landing-survey-text p {
        font-size: 12px;
        line-height: 1.7;
        font-weight: 400px;
        color: #fff;
        margin-top: 16px;
        margin-bottom: 24px;
        max-width: 905px;
    }
    .landing-survey-frame {
        position: relative;
        width: 100%;
        height: 500px;
        margin-top: -195px;
        margin-bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .landing-survey-phone img {
        max-height: 253px;
        width: 185px;
        display: block;
        margin: 0 auto;
        filter: drop-shadow(0 20px 40px rgba(0, 0, 0, 0.2));
    }

    /* Floating Cards */
    .card {
        position: absolute;
        border-radius: 6px;
        box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.69), 0 12px 40px rgba(0, 0, 0, 0.05);
        transition: transform 0.3s ease;
        z-index: 1;
    }

    .card1 {
        width: 60px;
        top: 150px;
        left: 10px;
        transform: rotate(-19deg);
    }

    .card2 {
        width: 90px;
        bottom: 147px;
        left: -20px;
    }

    .card3 {
        width: 60px;
        top: 150px;
        right: 10px;
        transform: rotate(-6deg);
    }

    .card4 {
        width: 95px;
        height: 80px;
        bottom: 150px;
        right: -29px;
        left: auto;
    }


    .msme-svg-wrapper {
        display: inline-block;
        margin-left: -10px;
        transform: translateY(0px); 
        background-image: url('../assets/img/MSME.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 100.74560546875px;
        height: 33.722381591796875px;
        font-size: 24px;
        color: white;
        text-align: center;
        line-height: 28px;
        user-select: none;
    }


    .why-choose {
        background: #fff;
        padding: 32px 24px;
    }

    .why-choose-wrapper {
        max-width: 1200px;
        margin: 0 auto;
    }

    .headline-section{
        flex-direction: column;
        align-items: flex-start; /* optional: align text to left */
        gap: 16px; /* reduce spacing if needed */
        margin-bottom: 24px;
    }

    .heading,
    .description{
        width: 100%; /* take full width for better stacking */
    }

    .heading {
        /* width: 440px; */
        font-size: 28px;
        font-weight: 600;
        color: #1a1a1a;
        line-height: 120%;
    }

    .description {
        /* width: 642px; */
        font-size: 14px;
        color: #737373;
        line-height: 26px;
    }

    .video-preview {
        width: 100%;
        height: 200px;
        background: #f0f0f0;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #666;
        font-style: italic;
    }


    /* Stats Section */
    .stats-section {
        padding: 32px 0;
        background-color: white;
    }

    .metrics-container {
        width: 100%;
        max-width: 364px;
        margin: 0 auto;
        border-radius: 12px;
        background: linear-gradient(194.52deg, #7970ef, #9792dc);
        padding: 24px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        gap: 16px;
        position: relative;
        color: #fafafa;
        text-align: center;
        font-family: 'Inter', sans-serif;
    }

    .metric-card {
        width: 238px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        justify-content: center;
        align-items: center;
        z-index: 1;
    }

    .metric-value {
        font-size: 16px;
        font-weight: 600;
        line-height: 120%;
    }

    .metric-label {
        font-size: 6px;
        font-weight: 500;
        line-height: 140%;
    }

    .app-preview {
        padding: 32px 20px 56px;
        background-color: #ffffff;
        text-align: center;
    }

    .app-preview h2 {
        font-size: 28px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 16px;
        padding: 0 10px;
    }

    .app-preview p {
        font-size: 14px;
        font-weight: 400;
        color: #1a1a1a;
        margin-bottom: 0;
        font-family: "Inter";
    }


    /* AI Loyalty Section */

    .first-text {
        order: 1;
    }
    
    .ai-loyalty-section {
        width: 100%;
        padding: 0 24px;
        background-color: #ffffff;
    }
    
    .ai-loyalty-title {
        font-size: 28px;
        font-weight: 600;
        color: #1a1a1a;
        margin-bottom: 20px;
        line-height: 120%;
        text-align: center;
    }
    .ai-loyalty-description {
        font-size: 14px;
        font-weight: 400;
        line-height: 26px;
        color: #4f4f4f;
        text-align: center;
        margin-bottom: 24px;
    }
    .ai-learn-more-btn {
        background-color: #000;
        color: #fff;
        padding: 12px 24px;
        border-radius: 999px;
        border: none;
        cursor: pointer;
        font-weight: 600;
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 134px;
    }

    .ai-loyalty-image-box {
        order: 2;
        width: 100%;
        max-width: 375px; /* Figma-like phone width */
        max-height: 322px;
        margin: 0 auto;
        border-radius: 24px;
        background: linear-gradient(179.93deg, #eeddea, #ffffff);
        overflow: hidden;
        padding: 28px 25px; /* Optional padding for spacing */
        box-sizing: border-box;
        position: relative;
    }

    /* .second-text {
        order: 3;
    } */

    .scan-screen-img {
        width: 100%;
        height: auto;
        object-fit: contain;
        border-radius: 24px;
        display: block;
        position: relative; /* remove absolute */
        top: auto;
        left: auto;
        transform: none;
    }

    .second-text{
        order: 3;
    }
    .reward-mockup-box {
        order: 4;
        width: 100%;
        max-width: 375px; /* same as ai-loyalty-image-box */
        max-height: 322px;
        margin: 0 auto;
        border-radius: 24px;
        background: linear-gradient(179.93deg, #eeddea, #ffffff);
        overflow: hidden;
        padding: 28px 25px;
        box-sizing: border-box;
        position: relative;
    }

    .reward-mockup-box img {
        width: 100%;
        height: auto;
        object-fit: contain;
        border-radius: 24px;
        display: block;
        position: relative;
        top: auto;
        left: auto;
        transform: none;
    }

    .real-surveys-section{
        padding: 56px 0 32px;
    }

    .real-surveys-container {
        max-width: 400px;
        max-height: 400px;
        padding: 52px 16px;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
        gap: 12px;
    }

    .real-surveys-text {
        max-width: 100%;
        text-align: center;
    }

    .real-surveys-text h2 {
        font-size: 24px;
        font-weight: 500;
        line-height: 1.2;
        margin-bottom: 3px;
    }

    .real-surveys-text p {
        font-size: 12px;
        line-height: 1.7;
        margin-bottom: 15px;
    }

    .explore-btn {
        font-size: 12px;
        font-weight: 500;
        padding: 6px 12px;
        width: auto;
        height: auto;
        white-space: nowrap;
        border-radius: 999px;
        margin: 0 auto;
    }

    .real-surveys-mockup {
        max-width: 100%;
        justify-content: center;
        display: flex;
    }

    .mockup-platform {
        padding: 8px;
        background: none;
        box-shadow: none;
    }

    .mockup-platform img {
        width: 100%;
        height: auto;
        border-radius: 16px;
        display: block;
    }

    /* benefit section - 6 grids */

    .benefits-section{
        background: #F6F7F9;
        width: auto;
        height: auto;
        padding: 32px;
    }
    .benefits-header {
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        gap: 32px; /* optional: adds spacing between text and graphic */
        padding: 40px 0;
        flex-wrap: wrap; /* allows wrapping on smaller screens */
    }

    .benefits-header h2 {
        font-family: 'Inter', sans-serif;
        color: #000;
        font-weight: 600;
        font-size: 28px;
        line-height: 120%;
        letter-spacing: 0;
        text-align: center;
        margin-bottom: 16px;
    }
    .benefits-header p {
        font-family: 'Inter', sans-serif;
        color: #000;
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
        letter-spacing: 0;
    }

    .benefits-grid {
        display: grid;
        grid-template-columns: none;
        gap: 28px;
        
    }
    .benefit-card {
        display: flex;
        gap: 24px;
        padding: 24px;
        background-color: #fff;
        border: 1px solid #dcdcdc;
        border-radius: 24px;
        box-sizing: border-box;
        font-family: Inter, sans-serif;
        align-items: flex-start;
    }
    .benefit-card:hover {
        background-color: #F1EFFF; /* soft purple */
        border: 1px solid #A38AF7; /* vivid purple */
        transition: all 0.3s ease;
        cursor: pointer;
    }

    .icon-inner img {
        width: 50px;
        height: 56px;
        object-fit: contain;
        border-radius: 12px;
        margin-top: 10px;
    }
        
    .headline {
        display: flex;
        flex-direction: column; /* Stack heading above paragraph */
        justify-content: center;
        /* gap: 24px; */
        font-family: Inter;
    }

    .headline h4 {
        font-size: 20px;
        font-weight: 600;
        margin: 0;
        color: #171717;
        line-height: 30px;
    }

    .headline p {
        font-size: 16px;
        color: #666d80;
        /* margin-top: 4px; */
        line-height: 24px;
        margin-bottom: 0;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
    }

    .brand-container {
        padding: 0;
    }
    .how-it-works-section {
        padding: 40px 15px;
    }
    .how-title {
        font-size: 28px;
    }
    .how-subtitle {
        font-size: 14px;
        margin-bottom: 25px;
    }
    .step-circle {
        display: none;
    }
    .how-steps {
        flex-direction: column;
        gap: 0;
    }
    .how-step {
        padding: 10px 20px;
    }

    .voucher-section {
        padding: 24px;
    }
    .voucher-header{
        text-align: center;
        margin-bottom: 32px;
    }
    .voucher-header h2{
        font-size: 28px;
        margin-bottom: 16px;
    }
    .voucher-header p{
        font-size: 15px;
    }
    .voucher-card{
        align-items: center;
    }
    .voucher-card img{
        width: 342px;
        margin-top: 10px;
    }
    .voucher-info h4{
        font-size: 18px;
        font-weight: 600;
    }
    .voucher-grid{
        flex-direction: column;
        gap: 24px;
        max-height: 840px; /* assuming ~420px per card */
        overflow: hidden;
    }
    .voucher-grid.show-all {
        max-height: none;
    }


}

@media (min-width: 768px) and(max-width: 1024px) {
    .card1{
        width: 143px; 
        top: -29px; 
        left:-42px;
    }
    .card2{
        width: 306px; 
        bottom: 2px; 
        left: -188px;
    }
    .card3{
        width: 162px; 
        top: -20px; 
        right: -26px;
    }
    .card4{
        width: 366px; 
        height: 314px; 
        bottom: 15px; 
        right: -241px; 
        left: auto;
    }
    .headline-section{
        gap: 36px;
    }
    .stats-section{
        padding: 88px 24px;
    }
    .real-surveys-section{
        padding: 100px 24px;
    }
    
    
    /* benefit section - 6 grids */

    .benefits-section{
        background: #F6F7F9;
        width: auto;
        height: auto;
        padding: 32px;
    }
    .benefits-header {
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        gap: 32px; /* optional: adds spacing between text and graphic */
        padding: 40px 0;
        flex-wrap: wrap; /* allows wrapping on smaller screens */
    }

    .benefits-header h2 {
        font-family: 'Inter', sans-serif;
        color: #000;
        font-weight: 600;
        font-size: 28px;
        line-height: 120%;
        letter-spacing: 0;
        text-align: center;
        margin-bottom: 16px;
    }
    .benefits-header p {
        font-family: 'Inter', sans-serif;
        color: #000;
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
        letter-spacing: 0;
    }

    .benefits-grid {
        display: grid;
        grid-template-columns: none;
        gap: 28px;
        
    }
    .benefit-card {
        display: flex;
        gap: 24px;
        padding: 24px;
        background-color: #fff;
        border: 1px solid #dcdcdc;
        border-radius: 24px;
        box-sizing: border-box;
        font-family: Inter, sans-serif;
        align-items: flex-start;
    }
    .benefit-card:hover {
        background-color: #F1EFFF; /* soft purple */
        border: 1px solid #A38AF7; /* vivid purple */
        transition: all 0.3s ease;
        cursor: pointer;
    }

    .icon-inner img {
        width: 50px;
        height: 56px;
        object-fit: contain;
        border-radius: 12px;
        margin-top: 10px;
    }
        
    .headline {
        display: flex;
        flex-direction: column; /* Stack heading above paragraph */
        justify-content: center;
        /* gap: 24px; */
        font-family: Inter;
    }

    .headline h4 {
        font-size: 20px;
        font-weight: 600;
        margin: 0;
        color: #171717;
        line-height: 30px;
    }

    .headline p {
        font-size: 16px;
        color: #666d80;
        /* margin-top: 4px; */
        line-height: 24px;
        margin-bottom: 0;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
    }
    .how-it-works-section {
        padding: 40px 15px;
    }
}

/* Responsive Design */
@media (max-width: 1024px) {

    .hero-text h1 {
        font-size: 48px;
    }

    .hero-text p {
        font-size: 16px;
    }
}

@media (min-width: 1200px) {
  .real-surveys-section {
    padding: 80px 120px;
  }
}


</style>
